import { Navigate, Outlet } from 'react-router-dom';
import { isSessionMismatch } from '../utils/sessionGuard';

export default function PrivateRoute() {
  const role = localStorage.getItem('Role');
  const id = localStorage.getItem('ID');
  const isAuthenticated = localStorage.getItem('isAuthenticated') === 'true';
  // super_admin is normalised to 'admin' in localStorage at login, but accept it
  // defensively so a raw super_admin value is never treated as invalid.
  const validRoles = ['admin', 'super_admin', 'doctor', 'patient'];

  // If not authenticated or missing required data, redirect to login
  if (!isAuthenticated || !id || !role || !validRoles.includes(role)) {
    return <Navigate to="/login" replace data-testid="private-route-redirect" />;
  }

  // Cross-tab session check: if another tab logged in/out as a different user,
  // this tab's per-tab id no longer matches the shared one. Bounce to /login
  // before rendering protected content with stale data.
  if (isSessionMismatch()) {
    return <Navigate to="/login" replace data-testid="private-route-stale-session" />;
  }

  return (
    <div data-testid="private-route" className="contents">
      <Outlet />
    </div>
  );
}